var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "common-content",
    [
      _c("page-title", { attrs: { pageName: _vm.pageName } }),
      _c("div", { staticClass: "join-produce" }, [
        _c("p", [_vm._v(_vm._s(_vm.intro))])
      ]),
      _c("div", { staticClass: "join-recruit" }, [
        _c("h2", [_vm._v(_vm._s(_vm.pros))]),
        _c("div", { staticClass: "join-recruit_content" }, [
          _c(
            "ul",
            { staticClass: "list" },
            _vm._l(_vm.descPageData, function(item, index) {
              return _c(
                "li",
                {
                  key: item.id,
                  staticClass: "join-li",
                  class: { joinActive: index === _vm.idx },
                  on: {
                    click: function($event) {
                      return _vm.toggle(index)
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "join-li-span",
                      class: { active: index === _vm.idx }
                    },
                    [_vm._v(_vm._s(item.title))]
                  ),
                  _c("span", { staticClass: "xiangqing" }, [
                    _vm._v(_vm._s(_vm.proe) + "\n            "),
                    _c("i", { staticClass: "icon icon-arrowright" })
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "detail-msg",
                      class: { detailActive: index === _vm.idxs }
                    },
                    [
                      _c("div", [_vm._v(_vm._s(_vm.pro))]),
                      _c(
                        "ul",
                        _vm._l(_vm.requ, function(item) {
                          return _c("li", [
                            _vm._v(
                              "\n                " +
                                _vm._s(item) +
                                "\n              "
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ]
              )
            }),
            0
          ),
          _c("div", { staticClass: "detail" }, [
            _c("div", [_vm._v(_vm._s(_vm.pro))]),
            _c(
              "ul",
              [
                _c("li"),
                _vm._l(_vm.requ, function(item) {
                  return _c("li", [
                    _vm._v("\n            " + _vm._s(item) + "\n          ")
                  ])
                })
              ],
              2
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb4497dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb4497dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/join.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bb4497dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/join.vue
// module chunks = 6